"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  if (action.type === _packagesConstants.PACKAGES_LOADED) {
    // Populate some optional fields so we can assume their existence elsewhere
    var name = action.packageJson.name;

    var allDependencies = new Set();
    if (action.packageJson.dependencies) {
      Object.keys(action.packageJson.dependencies).forEach(function (dep) {
        allDependencies.add(dep);
      });
    }
    if (action.packageJson.devDependencies) {
      Object.keys(action.packageJson.devDependencies).forEach(function (dep) {
        allDependencies.add(dep);
      });
    }
    if (!action.packageJson.wheelhouse) {
      action.packageJson.wheelhouse = {};
    }

    // Check all the existing packages and update the dependency tree as appropriate
    var localDependencies = [];
    var otherPackages = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = Object.keys(state)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var pkgName = _step.value;

        var otherPkg = state[pkgName];
        // Do we require this package?
        if (allDependencies.has(pkgName)) {
          localDependencies.push(pkgName);
        }

        // Does this package require us?
        if (state[pkgName].allDependencies.includes(name)) {
          otherPackages[pkgName] = _extends({}, otherPkg, {
            localDependencies: [].concat(_toConsumableArray(otherPkg.localDependencies), [name])
          });
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return _extends({}, state, otherPackages, _defineProperty({}, action.packageJson.name, {
      name: action.packageJson.name,
      packageJson: action.packageJson,
      path: action.path,
      allDependencies: [].concat(_toConsumableArray(allDependencies)),
      localDependencies: localDependencies
    }));
  }

  if (action.type === _packagesConstants.PACKAGES_UPLOADED) {
    return _extends({}, state, _defineProperty({}, action.name, _extends({}, state[action.name], {
      buildUrl: action.url
    })));
  }

  return state;
};

var _packagesConstants = require("./packagesConstants");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {};
//# sourceMappingURL=packagesReducer.js.map


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/dist/packages/packagesReducer.js
// module id = 251
// module chunks = 0